import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Optimizechicago() {
  return (
    <section className="leading_miami leading_dallas tekrevol_dark_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Explore the Potential of Mobile App Development in Dallas with
              TekRevol
            </h2>
            <p>
              Unlock the full potential of mobile app development in Dallas with
              TekRevol. We are at the forefront of innovative mobile solutions,
              leveraging cutting-edge technology to create apps that engage,
              captivate, and drive business success. Our expert team in Dallas
              is ready to transform your ideas into dynamic, user-friendly
              mobile applications, tailored to meet the unique needs of your
              audience. Whether you're a startup or an established business, let
              TekRevol be your partner in crafting mobile apps that elevate your
              brand and enhance your user experience.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Start Your App Development
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="leading_miami_img">
              <StaticImage
                src="../../images/location_new/dallas/potential_dallas.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={415}
                height={705}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Optimizechicago;
